import React from 'react';
import PropTypes from 'prop-types';
import { PrsButton, PrsDefaultButton } from '../../../../styles-and-themes/styles/prsButtons';
import { ButtonsContainer } from './BackAndContinueControlSetStyles';

const BackAndContinueControlSet = ({ onBack, onContinue, allFieldsValid }) => (
  <ButtonsContainer>
    <PrsButton type="button" className="back-button" onClick={onBack}>Back</PrsButton>
    <PrsDefaultButton type="submit" className="continue-button" onClick={onContinue} disabled={!allFieldsValid}>Continue</PrsDefaultButton>
  </ButtonsContainer>
);

BackAndContinueControlSet.propTypes = {
  onBack: PropTypes.func.isRequired,
  onContinue: PropTypes.func.isRequired,
  allFieldsValid: PropTypes.bool.isRequired,
};

export default BackAndContinueControlSet;
